import React from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { useNavigate } from 'react-router-dom'
const NotFound = () => {

    var navigate = useNavigate();

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <Breadcrumb>
                            <Breadcrumb.Item onClick={() => navigate("/home")}>Home</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </div>
            <div className='text-center'><h1>Page Not Found</h1></div>
        </>
    )
}

export default NotFound